module.exports = __webpack_public_path__ + "static/media/coinbase_banner.99210c72.png";